pageId = 'page-new-project'
page = '#' + pageId

$ ->
  $(document).on 'ajax:beforeSend', page + ' form.form', (e, xhr, settings) ->
    # set ajax param members
    membersGuid = $('.member.selected:not(.invited)').map ->
      $(@).data 'guid'
    .get()

    invitations = $('.member.invited.selected').map ->
      $(@).data 'guid'
    .get()

    settings.data += '&members=' + membersGuid.join(',') + '&invitations=' + invitations.join(',')

$(document).on 'pjaxload#' + pageId, (e, $page, page) ->
  tower.projectBadge target: '.btn-change-project-badge .badge'
  tower.initManageMembers $page
  tower.initManageMembersTabs $page.find('.manage-members-tabs')
  tower.fetchQrcode()
